import * as React from "react";

import { Progress as ProgressPrimitive } from "radix-ui";

import { cn } from "@/utils/cn";

function Progress({ className, value, ...props }: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn("relative h-1 w-full overflow-hidden rounded-full bg-primary/20", className)}
      {...props}
    >
      {/* Width-based fill anchors to the inline-start edge, so it grows
          left-to-right in LTR and right-to-left in RTL with no extra work. */}
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="h-full rounded-full bg-primary transition-[width]"
        style={{ width: `${value ?? 0}%` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
